import { createStyles, makeStyles, PopoverOrigin } from "@material-ui/core";
import { COLORS } from "../../../config/theme/theme";

export const selectBoxStyles = makeStyles((theme) =>
  createStyles({
    fieldLabel: { marginBottom: "8px" },
    formControl: {
      "& .MuiInputLabel-formControl": {
        width: "70%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        lineHeight: "16px",
      },
      "& .MuiInputLabel-outlined:not(.MuiInputLabel-shrink)": {
        transform: "translate(14px, 12px) scale(1)",
      },
      "& .hasLabel": {
        "& .MuiSelect-select": {
          paddingTop: theme.spacing(2),
          paddingBottom: 5,
          fontWeight: 500,
        },
      },
      "& .hasClearIcon": {
        "& .MuiSelect-select": {
          paddingRight: "50px !important",
        },
      },
      "&:hover": {
        top: "0px",
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: COLORS.BLACK_INPUT_BORDER,
          top: "0px",
        },
      },
      "& .open": {
        "& .MuiOutlinedInput-notchedOutline": {
          borderBottom: "none",
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
          border: "1px solid #0A437C",
          top: "0px",
        },
        "&:hover": {
          top: "0px",
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: COLORS.BLACK_INPUT_BORDER,
            top: "0px",
          },
        },
      },
      "& .MuiOutlinedInput-root.Mui-disabled": {
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "#E6E6E6",
          top: "0px",
        },
      },
      "& .MuiInputBase-formControl": {
        backgroundColor: COLORS.WHITE,
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#E6E6E6",
        top: "0px",
      },
    },
    menuPropsList: {
      "& .MuiListItem-root": {
        fontSize: 12,
        paddingLeft: theme.spacing(1.5),
        paddingRight: theme.spacing(1.5),
        whiteSpace: "normal",
      },
      "& .MuiCheckbox-root": {
        backgroundSize: "16px 16px",
        marginRight: theme.spacing(0.75),
      },
    },
    menuPropsPaper: {
      "& .open": {
        border: "1px solid #0A437C",
      },
      maxHeight: 200,
      border: "1px solid #0A437C",
      borderRadius: theme.spacing(1),
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      boxShadow: "none",
    },
    clearIcon: {
      position: "absolute",
      right: "30px",
      top: "calc(50% - 6px)",
      cursor: "pointer",
      color: "rgba(0, 0, 0, 0.54)",
      "&:hover": {
        color: "rgba(0, 0, 0, 0.87)",
      },
      zIndex: 1,
      width: "12px",
      height: "12px",
    },
  })
);

export const anchorOriginDefault: PopoverOrigin = {
  vertical: "bottom",
  horizontal: "left",
};
